// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"94eab8d6","507":"92990678","520":"bb817da6","714":"3bab94de","737":"58db6866","963":"1f7e0d44"}[chunkId] + ".chunk.js";
};